import wbnbImg from "./wbnb.png";
import aliceImg from "./alice.png";
import busdImg from "./busd.png";
import chainLinkImg from "./chain-link1.png";
import cakeImg from "./cake.png";
import raskoImg from "./rasko.png";
import bscPadImg from "./bscpad_logo.jpeg";
import quaiImg from "./quai.png";
import bifiImg from "./bifi.png";
import eyeImg from "./eye.png";
import polkaStarterImg from "./polkastarter.png";
import dxSaleImg from "./dxsale.png";
import swapzImg from "./swapz.jpeg";
import dodoImg from './dodo.png';
import xrpImg from './xrp.png';
import adaImg from './ada.png';
import oasisImg from './oasis.png';
import velasImg from './velas.png'
import venusImg from './venus.png'
import naftarImg from './naftar.png'

export default [
  wbnbImg,
  aliceImg,
  busdImg,
  chainLinkImg,
  cakeImg,
  quaiImg,
  raskoImg,
  bscPadImg,
  bifiImg,
  eyeImg,
  polkaStarterImg,
  dxSaleImg,
  swapzImg,
  dodoImg,
  xrpImg,
  adaImg,
  oasisImg,
  velasImg,
  venusImg,
  naftarImg
];
